import { render, staticRenderFns } from "./ResultFormSeBy.vue?vue&type=template&id=322ec0e1&scoped=true&"
import script from "./ResultFormSeBy.vue?vue&type=script&lang=js&"
export * from "./ResultFormSeBy.vue?vue&type=script&lang=js&"
import style0 from "./ResultFormSeBy.vue?vue&type=style&index=0&id=322ec0e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322ec0e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('322ec0e1')) {
      api.createRecord('322ec0e1', component.options)
    } else {
      api.reload('322ec0e1', component.options)
    }
    module.hot.accept("./ResultFormSeBy.vue?vue&type=template&id=322ec0e1&scoped=true&", function () {
      api.rerender('322ec0e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/ResultFormSeBy.vue"
export default component.exports